import { Component, OnInit } from '@angular/core';
import { PartnerStateService } from '../../../partner/services/partner-state.service';
import { Partner } from '../../../partner/models/partner';
import { KioskStateEnum } from '../../services/kiosk-state.enum';
import { KioskStateService } from '../../services/kiosk-state.service';

@Component({
  selector: 'app-kiosk-child-management',
  templateUrl: './kiosk-child-management.component.html',
  styleUrls: ['./kiosk-child-management.component.css']
})
export class KioskChildManagementComponent implements OnInit {

  private _activeComponentRef;

  constructor(
    protected partnerStateService: PartnerStateService,
    private kioskStateService: KioskStateService,
  ) {
  }

  ngOnInit() {
  }

  get partner(): Partner {
    return this.partnerStateService.loggedInPartner;
  }

  childListItemClicked($event) {
    this.kioskStateService.update(KioskStateEnum.EditChild, $event);
    if (this._activeComponentRef) {
      this._activeComponentRef.partner = this.partnerStateService.selectedChild.clone;
    }
  }

  onActivate(componentRef) {
    this._activeComponentRef = componentRef;
  }

}
